export default __webpack_public_path__ + "82fa14bb34ba27bf2af5d26cb4fb2559.svg";